export { NotFoundPage } from './index.pc'
export { MobileNotFoundPage } from './index.mobile'
